import React from "react";
import { IconError, IconInfo, IconSuccess, IconWarning } from "../icons";

const defaultCalloutIconByVariant = {
  success: IconSuccess,
  info: IconInfo,
  warning: IconWarning,
  error: IconError,
};

export default function AppCallout({
  variant = "primary",
  title = null,
  description = null,
  icon,
  action = null,
  className = "",
  ...rest
}) {
  const DefaultIcon = icon === undefined ? defaultCalloutIconByVariant[variant] : null;
  const resolvedIcon = icon === undefined && DefaultIcon ? <DefaultIcon /> : icon;
  const hasMainContent = Boolean(resolvedIcon || title || description);
  const classes = [
    "ds-callout",
    `ds-callout--${variant}`,
    !hasMainContent ? "ds-callout--action-only" : "",
    className,
  ]
    .filter(Boolean)
    .join(" ");

  return (
    <section className={classes} {...rest}>
      {hasMainContent ? (
        <div className="ds-callout__main">
          {resolvedIcon ? (
            <div className="ds-callout__icon" aria-hidden="true">
              {resolvedIcon}
            </div>
          ) : null}

          {(title || description) ? (
            <div className="ds-callout__copy">
              {title ? <div className="ds-callout__title">{title}</div> : null}
              {description ? <div className="ds-callout__description">{description}</div> : null}
            </div>
          ) : null}
        </div>
      ) : null}

      {action ? <div className="ds-callout__action">{action}</div> : null}
    </section>
  );
}
